// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BubbleChartController from "./bubble_chart_controller"
application.register("bubble-chart", BubbleChartController)

import ChartsController from "./charts_controller"
application.register("charts", ChartsController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import DropdownRedirectController from "./dropdown_redirect_controller"
application.register("dropdown-redirect", DropdownRedirectController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormAssignmentController from "./form_assignment_controller"
application.register("form-assignment", FormAssignmentController)

import FormFieldController from "./form_field_controller"
application.register("form-field", FormFieldController)

import FormSubmissionController from "./form_submission_controller"
application.register("form-submission", FormSubmissionController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import GoogleMapController from "./google_map_controller"
application.register("google-map", GoogleMapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhonePrefixController from "./phone_prefix_controller"
application.register("phone-prefix", PhonePrefixController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SlideOverController from "./slide_over_controller"
application.register("slide-over", SlideOverController)

import SparklineController from "./sparkline_controller"
application.register("sparkline", SparklineController)

import TaskAssignmentController from "./task_assignment_controller"
application.register("task-assignment", TaskAssignmentController)

import WebhookController from "./webhook_controller"
application.register("webhook", WebhookController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import BulkImportController from "./bulk_import_controller"
application.register("bulk-import", BulkImportController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import OpenstreetmapController from "./openstreetmap_controller"
application.register("openstreetmap", OpenstreetmapController)

import MapboxController from "./mapbox_controller"
application.register("mapbox", MapboxController)

import DynamicMapController from "./dynamic_map_controller"
application.register("dynamic-map", DynamicMapController)

import MapPerformanceMonitorController from "./map_performance_monitor_controller"
application.register("map-performance-monitor", MapPerformanceMonitorController)

import TaskController from "./task_controller"
application.register("task", TaskController)
